document.addEventListener('DOMContentLoaded', () => {
    Fancybox.bind('[data-fancybox]', {
        Carousel: {
            Toolbar: {
                display: {
                    right: ['close'],
                },
            },
            transition: 'slide'
        }
    });
});